import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import Font from '@maxpreps/shared/styles/font';
import styled from 'styled-components';
import { COLOR } from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';
import Anchor from '../Anchor/Anchor';

interface ISocialLinkConfig {
  text: string;
  icon: any;
  href: string;
}

const SOCIAL_LINKS: ISocialLinkConfig[] = [
  {
    text: 'facebook',
    icon: faFacebookSquare,
    href: 'https://www.facebook.com/maxpreps/'
  },
  {
    text: 'twitter',
    icon: faTwitter,
    href: 'https://twitter.com/MaxPreps'
  },
  {
    text: 'instagram',
    icon: faInstagram,
    href: 'https://www.instagram.com/maxpreps/?hl=en'
  }
];

export const StyledSocialLinksList = styled.ul`
  display: flex;

  letter-spacing: 2px;

  & > li {
    margin-left: 4px;

    & > a {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 22px;
      width: 44px;
      border-radius: 2px;
    }
  }
`;

const SocialLinksList: React.FC = () => (
  <StyledSocialLinksList className={Font.f11_bold_tall_upper}>
    {SOCIAL_LINKS.map(link => {
      const { text, href, icon } = link;

      return (
        <li key={text}>
          <Anchor href={href} target="_blank" rel="noopener noreferrer">
            <Icon icon={icon} size={16} color={COLOR.white} />
          </Anchor>
        </li>
      );
    })}
  </StyledSocialLinksList>
);

export default SocialLinksList;
